'use client';

import { usePathname } from 'next/navigation';
import Header from './Header';
import CartHeader from './CartHeader';
import SubcategoryHeader from './SubcategoryHeader'; // hypothetical extra header
import BlogHeader from './BlogHeader';
import { useCallback } from 'react';

export default function HeaderWrapper() {
  const pathname = usePathname();

  // Get the mobile menu toggle handler from the blog page
  const handleMobileMenuToggle = useCallback(() => {
    // This will be handled by the blog page's state
    const event = new CustomEvent('toggleBlogMobileMenu');
    window.dispatchEvent(event);
  }, []);

  if (pathname.startsWith('/cart')) {
    return <CartHeader />;
    // } else if (pathname.startsWith('/subcategory')) {
    //   return <SubcategoryHeader />;
    // } else if (pathname.startsWith('/blog-sortkaro')) {
    //   return <BlogHeader onMobileMenuToggle={handleMobileMenuToggle} />;
  } else {
    return <Header />;
  }
}
